import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useChat } from '../contexts/ChatContext';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Send, 
  Plus, 
  ArrowLeft, 
  Image, 
  Video, 
  Crown,
  Bot,
  User,
  Loader2,
  Settings,
  Sun,
  Moon,
  Trash2,
  Sparkles,
  Zap,
  Brain,
  Palette,
  Camera,
  Play,
  Pause,
  Download,
  Share2,
  MoreVertical,
  ChevronDown,
  ChevronUp,
  RotateCcw,
  Copy,
  ThumbsUp,
  ThumbsDown,
  Flag,
  Bookmark,
  Search,
  Filter,
  Grid,
  List,
  Maximize2,
  Minimize2,
  Volume2,
  VolumeX,
  Mic,
  MicOff,
  Phone,
  PhoneOff,
  VideoOff,
  MessageSquare,
  FileText,
  Code,
  Link,
  Smile,
  Frown,
  Heart,
  Star,
  Gift,
  Award,
  Target,
  TrendingUp,
  BarChart3,
  PieChart,
  Activity,
  Clock,
  Calendar,
  MapPin,
  Globe,
  Shield,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Bell,
  BellOff,
  Mail,
  Phone as PhoneIcon,
  Home,
  User as UserIcon,
  LogOut,
  Edit,
  Save,
  X,
  Check,
  AlertCircle,
  Info,
  HelpCircle,
  ExternalLink,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  Menu,
  X as XIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  SortAsc,
  SortDesc,
  RefreshCw,
  RefreshCcw,
  RotateCw,
  RotateCcw as RotateCcwIcon,
  ZoomIn,
  ZoomOut,
  Move,
  Crop,
  Scissors,
  Paintbrush,
  Eraser,
  Pen,
  Pencil,
  Highlighter,
  Type,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  List as ListIcon,
  ListOrdered,
  Quote,
  Code as CodeIcon,
  Terminal,
  Database,
  Server,
  Cloud,
  CloudOff,
  Wifi,
  WifiOff,
  Signal,
  SignalZero,
  SignalOne,
  SignalTwo,
  SignalThree,
  Battery,
  BatteryLow,
  BatteryMedium,
  BatteryHigh,
  BatteryFull,
  Plug,
  Unplug,
  Power,
  PowerOff,
  PlayCircle,
  PauseCircle,
  StopCircle,
  SkipBack,
  SkipForward,
  FastForward,
  Rewind,
  Shuffle,
  Repeat,
  RepeatOne,
  Volume1,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones,
  Speaker,
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Video as VideoIcon,
  VideoOff as VideoOffIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File,
  Folder,
  FolderOpen,
  FolderPlus,
  FolderMinus,
  FolderX,
  FilePlus,
  FileMinus,
  FileX,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileArchive,
  FileCode,
  FileSpreadsheet,
  FilePdf,
  FileWord,
  FilePowerpoint,
  FileExcel,
  FileZip,
  FileJson,
  FileXml,
  FileCsv,
  FileTxt,
  FileMd,
  FileHtml,
  FileCss,
  FileJs,
  FileTs,
  FileJsx,
  FileTsx,
  FileVue,
  FileSvelte,
  FileAngular,
  FileReact,
  FileNode,
  FilePython,
  FileJava,
  FileC,
  FileCpp,
  FileCsharp,
  FilePhp,
  FileRuby,
  FileGo,
  FileRust,
  FileSwift,
  FileKotlin,
  FileDart,
  FileR,
  FileScala,
  FileHaskell,
  FileClojure,
  FileLua,
  FilePerl,
  FileBash,
  FilePowershell,
  FileYaml,
  FileToml,
  FileIni,
  FileEnv,
  FileGitignore,
  FileDocker,
  FileKubernetes,
  FileTerraform,
  FileAnsible,
  FileJenkins,
  FileGithub,
  FileGitlab,
  FileBitbucket,
  FileAzure,
  FileAws,
  FileGcp,
  FileDigitalocean,
  FileHeroku,
  FileVercel,
  FileNetlify,
  FileSurge,
  FileFirebase,
  FileSupabase,
  FilePlanetscale,
  FileMongodb,
  FilePostgresql,
  FileMysql,
  FileRedis,
  FileElasticsearch,
  FileKibana,
  FileGrafana,
  FilePrometheus,
  FileJaeger,
  FileZipkin,
  FileSentry,
  FileLogrocket,
  FileMixpanel,
  FileAmplitude,
  FileSegment,
  FileRudderstack,
  FileSnowflake,
  FileBigquery,
  FileRedshift,
  FileS3,
  FileCloudfront,
  FileRoute53,
  FileCloudflare,
  FileFastly,
  FileAkamai,
  FileMaxcdn,
  FileKeycdn,
  FileBunnycdn,
  FileStackpath,
  FileCloudinary,
  FileImgix,
  FileImagekit,
  FileUploadcare,
  FileFilestack,
  FileDropzone,
  FileTus,
  FileResumable,
  FileChunked,
  FileStreaming,
  FileProgressive,
  FileLazy,
  FileEager,
  FileOptimized,
  FileCompressed,
  FileMinified,
  FileBundled,
  FileTranspiled,
  FilePolyfilled,
  FileShimmed,
  FilePonyfilled,
  FileProlyfilled,
  FilePolyfilled as PolyfilledIcon,
  FileShimmed as ShimmedIcon,
  FilePonyfilled as PonyfilledIcon,
  FileProlyfilled as ProlyfilledIcon
} from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import toast from 'react-hot-toast';

const ModernChatInterface = () => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { 
    currentChat, 
    messages, 
    loading, 
    setCurrentChat, 
    fetchMessages, 
    sendMessage, 
    generateImage, 
    generateVideo,
    deleteChat
  } = useChat();
  
  const [inputMessage, setInputMessage] = useState('');
  const [selectedModel, setSelectedModel] = useState('gpt-3.5-turbo');
  const [isGenerating, setIsGenerating] = useState(false);
  const [showMediaOptions, setShowMediaOptions] = useState(false);
  const [showModelSelector, setShowModelSelector] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingText, setTypingText] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [messageFilters, setMessageFilters] = useState({
    type: 'all',
    date: 'all',
    user: 'all'
  });
  
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const searchInputRef = useRef(null);

  // AI Models Configuration
  const aiModels = [
    {
      id: 'gpt-3.5-turbo',
      name: 'GPT-3.5 Turbo',
      description: 'Hızlı ve etkili sohbet',
      icon: Zap,
      color: 'bg-green-500',
      available: true,
      premium: false
    },
    {
      id: 'gpt-4',
      name: 'GPT-4',
      description: 'En gelişmiş OpenAI modeli',
      icon: Brain,
      color: 'bg-purple-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'gpt-4-turbo',
      name: 'GPT-4 Turbo',
      description: 'Hızlı GPT-4 versiyonu',
      icon: Sparkles,
      color: 'bg-indigo-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'claude-3-haiku',
      name: 'Claude 3 Haiku',
      description: 'Hızlı ve verimli Claude',
      icon: Bot,
      color: 'bg-orange-500',
      available: true,
      premium: false
    },
    {
      id: 'claude-3-sonnet',
      name: 'Claude 3 Sonnet',
      description: 'Güçlü Claude modeli',
      icon: Crown,
      color: 'bg-yellow-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'claude-3-opus',
      name: 'Claude 3 Opus',
      description: 'En gelişmiş Claude modeli',
      icon: Award,
      color: 'bg-red-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'gemini-pro',
      name: 'Gemini Pro',
      description: 'Google\'ın gelişmiş modeli',
      icon: Globe,
      color: 'bg-blue-500',
      available: true,
      premium: false
    },
    {
      id: 'gemini-pro-vision',
      name: 'Gemini Pro Vision',
      description: 'Görsel anlayışlı Gemini',
      icon: Eye,
      color: 'bg-cyan-500',
      available: user?.is_premium,
      premium: true
    }
  ];

  // Image Models Configuration
  const imageModels = [
    {
      id: 'dall-e-2',
      name: 'DALL-E 2',
      description: 'OpenAI görsel üretim modeli',
      icon: Image,
      color: 'bg-pink-500',
      available: true,
      premium: false
    },
    {
      id: 'dall-e-3',
      name: 'DALL-E 3',
      description: 'En gelişmiş görsel üretim',
      icon: Sparkles,
      color: 'bg-purple-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'stable-diffusion-xl',
      name: 'Stable Diffusion XL',
      description: 'Açık kaynak görsel üretim',
      icon: Palette,
      color: 'bg-green-500',
      available: true,
      premium: false
    },
    {
      id: 'stable-diffusion-3',
      name: 'Stable Diffusion 3',
      description: 'En yeni Stable Diffusion',
      icon: Crown,
      color: 'bg-indigo-500',
      available: user?.is_premium,
      premium: true
    },
    {
      id: 'flux-dev',
      name: 'Flux Dev',
      description: 'Hızlı ve kaliteli görsel',
      icon: Zap,
      color: 'bg-orange-500',
      available: true,
      premium: false
    }
  ];

  // Video Models Configuration
  const videoModels = [
    {
      id: 'stable-video-diffusion',
      name: 'Stable Video Diffusion',
      description: 'Açık kaynak video üretim',
      icon: Video,
      color: 'bg-blue-500',
      available: true,
      premium: false
    },
    {
      id: 'zeroscope-v2',
      name: 'Zeroscope V2',
      description: 'Hızlı video üretimi',
      icon: Play,
      color: 'bg-green-500',
      available: true,
      premium: false
    },
    {
      id: 'animatediff',
      name: 'AnimateDiff',
      description: 'Animasyonlu video üretimi',
      icon: Sparkles,
      color: 'bg-purple-500',
      available: true,
      premium: false
    },
    {
      id: 'runway-gen-3',
      name: 'Runway Gen-3',
      description: 'Yüksek kaliteli video',
      icon: Crown,
      color: 'bg-red-500',
      available: user?.is_premium,
      premium: true
    }
  ];

  useEffect(() => {
    if (chatId) {
      setCurrentChat({ id: parseInt(chatId) });
      fetchMessages(parseInt(chatId));
    }
  }, [chatId, setCurrentChat, fetchMessages]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = messages.filter(msg => 
        msg.content.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredMessages(filtered);
    } else {
      setFilteredMessages(messages);
    }
  }, [searchQuery, messages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || isGenerating) return;

    const message = inputMessage.trim();
    setInputMessage('');
    setIsGenerating(true);

    try {
      await sendMessage(parseInt(chatId), message, selectedModel);
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error('Mesaj gönderilirken hata oluştu');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleGenerateImage = async () => {
    if (!inputMessage.trim() || isGenerating) return;

    const prompt = inputMessage.trim();
    setInputMessage('');
    setIsGenerating(true);

    try {
      const selectedImageModel = imageModels[0]; // Default to first available
      await generateImage(parseInt(chatId), prompt, selectedImageModel.id);
      toast.success('Görsel oluşturuluyor...');
    } catch (error) {
      console.error('Error generating image:', error);
      toast.error('Görsel oluşturulurken hata oluştu');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleGenerateVideo = async () => {
    if (!inputMessage.trim() || isGenerating) return;

    const prompt = inputMessage.trim();
    setInputMessage('');
    setIsGenerating(true);

    try {
      const selectedVideoModel = videoModels[0]; // Default to first available
      await generateVideo(parseInt(chatId), prompt, selectedVideoModel.id);
      toast.success('Video oluşturuluyor...');
    } catch (error) {
      console.error('Error generating video:', error);
      toast.error('Video oluşturulurken hata oluştu');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('tr-TR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getModelIcon = (modelId) => {
    const model = aiModels.find(m => m.id === modelId);
    return model ? model.icon : Bot;
  };

  const getModelColor = (modelId) => {
    const model = aiModels.find(m => m.id === modelId);
    return model ? model.color : 'bg-gray-500';
  };

  const renderMessage = (message, index) => {
    const isUser = message.role === 'user';
    const MessageIcon = isUser ? User : getModelIcon(selectedModel);
    const colorClass = isUser ? 'bg-blue-500' : getModelColor(selectedModel);

    return (
      <motion.div
        key={index}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}
      >
        <div className={`flex items-start space-x-3 max-w-3xl ${isUser ? 'flex-row-reverse space-x-reverse' : ''}`}>
          <div className={`flex-shrink-0 w-8 h-8 rounded-full ${colorClass} flex items-center justify-center`}>
            <MessageIcon className="w-4 h-4 text-white" />
          </div>
          <div className={`flex-1 ${isUser ? 'text-right' : 'text-left'}`}>
            <div className={`inline-block px-4 py-2 rounded-2xl ${
              isUser 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-100 text-gray-900 dark:bg-gray-800 dark:text-white'
            }`}>
              {message.message_type === 'text' ? (
                <ReactMarkdown
                  components={{
                    code({ node, inline, className, children, ...props }) {
                      const match = /language-(\w+)/.exec(className || '');
                      return !inline && match ? (
                        <SyntaxHighlighter
                          style={vscDarkPlus}
                          language={match[1]}
                          PreTag="div"
                          {...props}
                        >
                          {String(children).replace(/\n$/, '')}
                        </SyntaxHighlighter>
                      ) : (
                        <code className={className} {...props}>
                          {children}
                        </code>
                      );
                    }
                  }}
                >
                  {message.content}
                </ReactMarkdown>
              ) : message.message_type === 'image' ? (
                <div className="space-y-2">
                  <img 
                    src={message.content} 
                    alt="Generated" 
                    className="max-w-full h-auto rounded-lg"
                  />
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {message.metadata?.prompt || 'Generated image'}
                  </p>
                </div>
              ) : message.message_type === 'video' ? (
                <div className="space-y-2">
                  <video 
                    src={message.content} 
                    controls 
                    className="max-w-full h-auto rounded-lg"
                  />
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {message.metadata?.prompt || 'Generated video'}
                  </p>
                </div>
              ) : (
                <p>{message.content}</p>
              )}
            </div>
            <div className={`text-xs text-gray-500 mt-1 ${isUser ? 'text-right' : 'text-left'}`}>
              {formatTime(message.timestamp)}
            </div>
          </div>
        </div>
      </motion.div>
    );
  };

  return (
    <div className={`h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 flex flex-col overflow-hidden ${
      isFullscreen ? 'fixed inset-0 z-50' : ''
    }`}>
      {/* Modern Header */}
      <div className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-gray-700/50 p-4 flex items-center justify-between flex-shrink-0">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate('/')}
            className="p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
              <Bot className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                {currentChat?.title || 'Yeni Sohbet'}
              </h1>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setShowModelSelector(!showModelSelector)}
                  className="flex items-center space-x-2 px-3 py-1.5 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  <User className="w-4 h-4" />
                  <span className="text-sm font-medium">{selectedModel}</span>
                  <ChevronDown className="w-3 h-3" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => setShowSearch(!showSearch)}
            className="p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <Search className="w-5 h-5" />
          </button>
          
          <button
            onClick={() => setShowSettings(!showSettings)}
            className="p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <Settings className="w-5 h-5" />
          </button>
          
          <button
            onClick={() => setIsFullscreen(!isFullscreen)}
            className="p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            {isFullscreen ? <Minimize2 className="w-5 h-5" /> : <Maximize2 className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Model Selector */}
      <AnimatePresence>
        {showModelSelector && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4"
          >
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {aiModels.map((model) => (
                <button
                  key={model.id}
                  onClick={() => {
                    setSelectedModel(model.id);
                    setShowModelSelector(false);
                  }}
                  disabled={!model.available}
                  className={`p-3 rounded-xl border-2 transition-all ${
                    selectedModel === model.id
                      ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                      : model.available
                      ? 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
                      : 'border-gray-100 dark:border-gray-800 opacity-50 cursor-not-allowed'
                  }`}
                >
                  <div className="flex items-center space-x-2">
                    <div className={`w-8 h-8 rounded-lg ${model.color} flex items-center justify-center`}>
                      <model.icon className="w-4 h-4 text-white" />
                    </div>
                    <div className="text-left">
                      <div className="font-medium text-sm">{model.name}</div>
                      <div className="text-xs text-gray-500">{model.description}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Search Bar */}
      <AnimatePresence>
        {showSearch && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4"
          >
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Mesajlarda ara..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-700 rounded-xl bg-gray-50 dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Messages Area */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <AnimatePresence>
          {filteredMessages.map((message, index) => renderMessage(message, index))}
        </AnimatePresence>
        
        {isGenerating && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex justify-start mb-4"
          >
            <div className="flex items-start space-x-3 max-w-3xl">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-500 flex items-center justify-center">
                <Bot className="w-4 h-4 text-white" />
              </div>
              <div className="flex-1">
                <div className="inline-block px-4 py-2 rounded-2xl bg-gray-100 dark:bg-gray-800">
                  <div className="flex items-center space-x-2">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Yanıt oluşturuluyor...</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
        
        <div ref={messagesEndRef} />
      </div>

      {/* Media Options */}
      <AnimatePresence>
        {showMediaOptions && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4"
          >
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <button
                onClick={handleGenerateImage}
                disabled={isGenerating}
                className="p-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
              >
                <div className="flex items-center space-x-2">
                  <Image className="w-5 h-5 text-pink-500" />
                  <span className="font-medium">Görsel Oluştur</span>
                </div>
              </button>
              
              <button
                onClick={handleGenerateVideo}
                disabled={isGenerating}
                className="p-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
              >
                <div className="flex items-center space-x-2">
                  <Video className="w-5 h-5 text-blue-500" />
                  <span className="font-medium">Video Oluştur</span>
                </div>
              </button>
              
              <button
                onClick={() => setShowFileUpload(true)}
                className="p-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <FileText className="w-5 h-5 text-green-500" />
                  <span className="font-medium">Dosya Yükle</span>
                </div>
              </button>
              
              <button
                onClick={() => setShowEmojiPicker(true)}
                className="p-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Smile className="w-5 h-5 text-yellow-500" />
                  <span className="font-medium">Emoji</span>
                </div>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Input Area */}
      <div className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-t border-gray-200/50 dark:border-gray-700/50 p-4 flex-shrink-0">
        <div className="flex items-end space-x-3">
          <button
            onClick={() => setShowMediaOptions(!showMediaOptions)}
            className="p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <Plus className="w-5 h-5" />
          </button>
          
          <div className="flex-1 relative">
            <textarea
              ref={inputRef}
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Mesajınızı yazın..."
              className="w-full px-4 py-3 pr-12 border border-gray-200 dark:border-gray-700 rounded-2xl bg-gray-50 dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              rows={1}
              style={{ minHeight: '48px', maxHeight: '120px' }}
            />
            
            <div className="absolute right-2 bottom-2 flex items-center space-x-1">
              <button
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                className="p-1.5 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                <Smile className="w-4 h-4 text-gray-500" />
              </button>
              
              <button
                onClick={handleSendMessage}
                disabled={!inputMessage.trim() || isGenerating}
                className="p-1.5 rounded-lg bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                <Send className="w-4 h-4 text-white" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModernChatInterface;
